import {
  getLogoSrc,
  useFetchCustomerQuery,
  CustomerSelect
} from 'modules/Customer'

import { Card, CustomerLogo } from '@sequencehq/core-components'
import { getBillingContacts } from 'modules/CustomerContacts'
import { useState } from 'react'
import { EditCustomerModalForm } from 'components/EditCustomer/EditCustomerModalForm'
import { RowControl } from 'Invoices/components'
import { useSetAtom } from 'jotai'
import { clientInvoiceAtom } from 'Invoices/atoms/invoiceEditing.atom'
import Spinner from 'components/Loading'

export const InvoiceCustomerCard = ({ customerId }: { customerId: string }) => {
  const { customerDetails: customer, refetch } =
    useFetchCustomerQuery(customerId)
  const [showEditCustomerDrawer, setShowEditCustomerDrawer] = useState(false)
  const [switchingCustomer, setSwitchingCustomer] = useState(false)

  const partialUpdateInvoice = useSetAtom(clientInvoiceAtom)

  if (!customer) {
    return (
      <Card variant="v2" padding="0 16px" height="68px">
        <Spinner />
      </Card>
    )
  }

  const billingContacts = getBillingContacts(customer.contacts)

  if (switchingCustomer) {
    return (
      <CustomerSelect
        onChange={newCustomerId => {
          partialUpdateInvoice({ customerId: newCustomerId })
          setSwitchingCustomer(false)
        }}
        value={customerId}
        initiallyOpen
      />
    )
  }

  return (
    <>
      <Card variant="v2" padding="0 16px">
        <RowControl
          title={customer.legalName}
          body={billingContacts.map(contact => contact.email).join(', ')}
          icon={
            <CustomerLogo
              src={getLogoSrc(customer)}
              size={32}
              fallbackSize={16}
            />
          }
          hideBorderBottom
        />
      </Card>
      {showEditCustomerDrawer && (
        <EditCustomerModalForm
          customerId={customerId}
          onClose={() => {
            setShowEditCustomerDrawer(false)
            void refetch()
          }}
        />
      )}
    </>
  )
}
